<template>
    <section id="content" v-if="get_FlagRebookingShowBookingnoSearchResults">
        <div class="container">
            <div class="block" id="contentElementRebookingBookingno">
                <!-- >>> BreadCrumbs - Row -->
                <div class="row">
                    <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                    <sdr-breadcrumbs active_item="first" :module="modulo"></sdr-breadcrumbs>
                    <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                </div>
                <!-- <<< BreadCrumbs - Row -->


                <!-- >>> 'Bookingno Search Results' - Row -->
                <div class="row">
                    <div class="container shortcode travel-ideas">
                        <h1 class="idea-title" style="margin-bottom:30px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ headline_step1[getCurrentLocale] }}</h1>
                    </div>


                    <!-- >>> Left Side: 'Booking Details' -->
                    <sdr-rebooking-bookingno-bookingdetails :modulo="modulo" mode="overview"></sdr-rebooking-bookingno-bookingdetails>
                    <!-- <<< Left Side: 'Booking Details' -->


                    <!-- >>> Right Side: Sidebar -->
                    <div class="sidebar col-sms-6 col-sm-4 col-md-3 topDistance" style="">
                        <h2>&nbsp;</h2>
                        <h4 class="search-results-title"><i class="soap-icon-search"></i><b>{{ get_RebookingGetBookingResults.passengers.length }}</b> {{ resultsshown[getCurrentLocale] }}.</h4>
                    </div>
                    <!-- <<< Right Side: Sidebar -->
                </div>
                <!-- <<< 'Bookingno Search Results' - Row -->
            </div>
        </div>
    </section>
</template>

<script>
    import BookingDetails from './BookingnoBookingDetails.vue';
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-rebooking-bookingno-bookingdetails': BookingDetails,
            'sdr-breadcrumbs': Breadcrumbs,

        }, // eo components
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                headline_step1: {
                    en: 'Step 1: Your original booking and rebooking data.',
                    de: 'Schritt 1: Ihre originalen Buchungs- und Umbuchungsdaten.'
                },
                proceed: {
                    en: 'Proceed to Book seats and services',
                    de: 'Weiter zu Sitzplätze und Services buchen'
                },
                resultsshown: {
                    en: 'Passenger(s) found',
                    de: 'Passagier(e) gefunden'
                },
                // ----------------------------------------
                tab_flightdetails: {
                    en: 'Your original booking',
                    de: 'Ihre ursprüngliche Buchung'
                },
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_FlagRebookingShowBookingnoSearchResults', // Control Flag
                'get_RebookingGetBookingResults',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([

            ]),

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
</style>
